import anime from 'animejs/lib/anime.min.js';
import Templates from "./templates";
import Api from "../../../../lib/api";
import Element from "../../../../components/base/element";

export default class ResultScreen extends Element {
	constructor(props) {
		super(props);

		this.$root = document.getElementById('resultScreen');
		this.$categoriesContainer = document.getElementById('resultCategories');
		this.$coursesContainer = document.getElementById('resultCourses');
		this.$detailsContainer = document.getElementById('resultDetails');
		this.$newTestTrigger = document.getElementById('resultDetailsNew');
		this.$showDetailsTrigger = document.getElementById('resultDetailsShow');
		this.$detailsCollapsible = document.getElementById('resultDetailsCollapsible');

		this.dataManager = null;

		this.answers = null;
		this.categories = null;
		this.courses = null;
		this.details = null;

		this.START_NEW_TEST_EVENT = 'startNewTest';

		this.bootstrapNewTestHandler = this.bootstrapNewTestHandler.bind(this);
		this.collapseDetailsHandler = this.collapseDetailsHandler.bind(this);
	}

	init(dataManager) {
		const hash = window.location.hash;

		this.dataManager = dataManager;

		this.answers = this.dataManager.parseHashedAnswers(hash);
		this.categories = [];
		this.courses = [];
		this.details = [];

		this.distributeResults();
		this.render();
		this.removeEventListeners();

		super.init();
	}

	addEventListeners() {
		this.removeEventListeners();

		this.$showDetailsTrigger.addEventListener('click', this.collapseDetailsHandler);
		this.$newTestTrigger.addEventListener('click', this.bootstrapNewTestHandler);
	}

	removeEventListeners() {
		this.$showDetailsTrigger.removeEventListener('click', this.collapseDetailsHandler);
		this.$newTestTrigger.removeEventListener('click', this.bootstrapNewTestHandler);
	}

	bootstrapNewTestHandler() {
		this.dataManager.resetAnswers();
		this.dispatchEvent(this.START_NEW_TEST_EVENT);
	}

	collapseDetailsHandler() {
		if (this.$detailsCollapsible.classList.contains('-show')) {
			this.$showDetailsTrigger.classList.remove('-active');
			this.$detailsCollapsible.classList.remove('-show');
		} else {
			const containerHeight = this.$detailsContainer.offsetHeight;
			this.$detailsCollapsible.style.maxHeight = containerHeight + 'px';
			this.$detailsCollapsible.classList.add('-show');
			this.$showDetailsTrigger.classList.add('-active');
		}
	}

	distributeResults() {
		this.answers
			.filter(item => !isNaN(+item.sectionId))
			.forEach(item => {
				const section = this.dataManager.getSection(item.sectionId);

				/* Categories*/
				if (this.categories.length < 3) {
					this.categories.push({
						title: section.title,
						iconSrc: section.icon,
						gradientFrom: section.iconGradientFrom,
						gradientTo: section.iconGradientTo,
						rate: item.rate
					});

					/* Courses */
					section.courses.forEach((courseItem) => {
						const cityId = Api.currentCityId;
						const courseInfo = courseItem.cities[cityId];

						if (courseInfo) {
							this.courses.push({
								href: courseInfo.url,
								title: courseInfo.title,
								type: courseInfo.grade,
								isOnline: courseInfo.isOnline,
								isSprint: courseInfo.isSprint,
								iconSrc: courseInfo.icon,
								gradientFrom: courseInfo.iconGradientFrom,
								gradientTo: courseInfo.iconGradientTo
							});
						}
					});
				}

				/* Details */
				this.details.push({
					title: section.title,
					value: +item.rate * 100
				});
			});
	}

	render() {
		this.renderCategories();
		this.renderCourses();
		this.renderDetails();
	}

	renderCategories(animationComplete) {
		this.$categoriesContainer.innerHTML = '';

		this.categories.forEach((category, i) => {
			const template = Templates.getCategoryItemTemplate(category);
			this.$categoriesContainer.insertAdjacentHTML('beforeend', template);
		});

		const $elements = this.$categoriesContainer.children;
		const $charts = Array.from($elements).map(($el) => $el.querySelector('.svg-pie_chart'));

		/* Showing animation */
		anime({
			targets: $elements,
			translateY: [50, 0],
			opacity: 1,
			delay: (el, i, l) => {
				return i * 150;
			},
			duration: 540,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
		});

		/* Charts animation */
		anime({
			targets: $charts,
			strokeDasharray: (el, i) => {
				const values = this.categories;
				const value = 201 * +values[i].rate;
				return `${value} 300`;
			},
			delay: (el, i, l) => {
				return 540 + i * 150;
			},
			duration: 540,
			easing: 'easeOutCubic',
			complete: () => {
				if (animationComplete) {
					animationComplete();
				}
			}
		});
	}

	renderCourses() {
		this.$coursesContainer.innerHTML = '';

		this.courses.forEach((course, i) => {
			const template = course.isSprint ? Templates.getSprintBarTemplate(course) : Templates.getCourseBarTemplate(course);
			this.$coursesContainer.insertAdjacentHTML('beforeend', template);
		});

		const $title = this.$root.querySelector('.result-courses_title');
		const $elements = this.$coursesContainer.children;

		/* Showing animation */
		anime({
			targets: [$title, ...$elements],
			translateY: [50, 0],
			opacity: 1,
			delay: (el, i, l) => {
				return 360 + i * 150;
			},
			duration: 540,
			easing: 'cubicBezier(0.32, 0.08, 0.24, 1)'
		});
	}

	renderDetails() {
		this.$detailsContainer.innerHTML = '';

		this.details.forEach((detail, i) => {
			const template = Templates.getResultItemTemplate(detail);
			this.$detailsContainer.insertAdjacentHTML('beforeend', template);
		});
	}
}
